declare module "@vue/runtime-core" {

  interface ComponentCustomProperties {
    $filters: {
      formatDateTZ: (value: string | Date | number | undefined) => string;
      formatDate: (value: string | Date | number | undefined) => string;
      formatDateAlt: (value: string | Date | number | undefined) => string;
      formatShortDate: (value: string | Date | number | undefined) => string;
      formatDateTime: (value: string | Date | number | undefined) => string;
      formatDateTimeTZ: (value: string | Date | number | undefined) => string;
      formatShortDateTime: (value: string | Date | number | undefined) => string;
      formatShortDateTimeYear: (value: string | Date | number | undefined) => string;
      formatShortDateTimeTZ: (value: string | Date | number | undefined) => string;
      formatTime: (value: string | Date | number | undefined) => string;
      formatMonth: (value: string | Date | number | undefined) => string;
      formatPhone: (value: string) => string;
      formatSecondsToTime: (seconds: number) => string;
    };
  }
}

import {Locale} from "date-fns";
import {enCA, frCA} from "date-fns/locale";

// Maps an i18n locale string to its corresponding date-fns Locale object.
function mapLocaleToDateFns(locale: string): Locale {
  if (locale.startsWith('fr')) {
    return frCA
  }
  return enCA
}

// Builds the shared date formatting context (parsed date, timezone, format string, and locale) used by date filters.
export function getDateContext(value: string | Date | number, i18n: any) {
  return {
    date: new Date(value),
    localTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    formatString: 'M/d/yy H:mm zz',
    locale: mapLocaleToDateFns(i18n.global.locale.value)
  }
}
